import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { WorkspaceCreationWith } from "../../interfaces/interfaces";

const INITIAL_STATE = {
  temporaryWorkspacesList: [],
  temporaryWorkspaces: {},
  isConsolidated: true,
  isInProgress: false,
  isError: false,
  isComparison: false,
  viewSelectRefresh: {
    reportVersionId: 0,
    changeVersion: false,
  },
  isTemp: false,
  temporaryVersionIndex: null,
  errorMessage: "",
  jobId: 0,
  type: WorkspaceCreationWith.NOTHING,
  redirectUrl: "",
  isTemporary: false,
  params: {
    ids: null,
    // type: null,
    // value: null,
    // startDate: null,
    // endDate: null,
    isComparison: false,
    customDataPeriodObj: null,
    compareToDatePeriodObj: null,
  },
  fetchDefaultWs: false,
};

const temporaryWorkspace = createSlice({
  name: "temporaryWorkspace",
  initialState: INITIAL_STATE,
  reducers: {
    addTempWorkspace: (state, action) => {
      // console.log("add tempwslist");
      state.temporaryWorkspaces = {
        ...state.temporaryWorkspaces,
        [action.payload.reportId]: action.payload.data,
      };
      state.temporaryWorkspacesList = [
        ...state.temporaryWorkspacesList,
        action.payload.reportId,
      ];
    },
    deleteTempWorkspace: (state, action) => {
      // console.log("delete tempwslist");
      state.temporaryWorkspacesList = [];
      state.temporaryWorkspaces = {};
      state.isComparison = false;
    },
    permanentToggleIsInProgress: (state, action) => {
      if (state.isInProgress) {
        state.isInProgress = !state.isInProgress;
      }
    },
    viewSelectRefreshToggle: (state, action) => {
      // if jobId is not null, then check if the
      // jobId is the same as the one in the state
      if (action.payload?.jobId) {
        if (action.payload?.jobId != state.jobId) return;
      }

      if (action.payload?.toggleIsInProgress)
        state.isInProgress = !state.isInProgress;

      state.viewSelectRefresh.changeVersion = action.payload.changeVersion;
      state.viewSelectRefresh.reportVersionId = action.payload.reportVersionId;
    },
    toggleIsInProgress: (state, action) => {
      state.type = action?.payload?.type
        ? action.payload.type
        : WorkspaceCreationWith.NOTHING;
      state.isInProgress = !state.isInProgress;
    },
    setRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload;
    },
    setParams: (state, action) => {
      state.params = action.payload?.params;
    },
    setError: (state, action) => {
      if (state.jobId == action.payload?.data?.jobId) {
        state.isError = !state.isError;
        state.errorMessage = action.payload.message;

        if (state.isInProgress) {
          state.isInProgress = false;
        }
      }
    },
    setIsTemporary: (state, action) => {
      state.isTemporary = action.payload;
    },
    setJobId: (state, action) => {
      state.jobId = action.payload;
      // console.log("view reducer", state.jobId);
    },
    setIsConsolidated: (state, action) => {
      state.isConsolidated = action.payload;
    }, // temporaryUpdate: (state, action) => {
    //   if (state.isInProgress) {
    //     state.isInProgress = !state.isInProgress;
    //     state.temporaryWorkspaces = {
    //       ...state.temporaryWorkspaces,
    //       [action.payload.reportId]: action.payload.data,
    //     };
    //     state.temporaryWorkspacesList = [
    //       ...state.temporaryWorkspacesList,
    //       action.payload.reportId,
    //     ];
    //   }
    // },
    temporaryUpdate: (state, action) => {
      if (state.jobId != action.payload?.jobId) return;

      if (state.isInProgress) {
        const temporaryVersionIndex = state.temporaryWorkspaces[
          action.payload.reportId
        ]
          ? state.temporaryWorkspaces[action.payload.reportId].length
          : 0;

        let olderAndNewWorkspaces =
          state.temporaryWorkspaces[action.payload.reportId] &&
          state.temporaryWorkspaces[action.payload.reportId].length
            ? [
                ...state.temporaryWorkspaces[action.payload.reportId],
                action.payload.data,
              ]
            : [action.payload.data];
        // console.log("combined workspaces", olderAndNewWorkspaces);

        state.temporaryWorkspaces = {
          ...state.temporaryWorkspaces,
          [action.payload.reportId]: olderAndNewWorkspaces,
        };
        state.temporaryVersionIndex = temporaryVersionIndex;
        state.temporaryWorkspacesList = [
          ...state.temporaryWorkspacesList,
          action.payload.reportId,
        ];

        if (action.payload?.data?.jobDetails?.isComparison) {
          state.isComparison = true;
        } else {
          state.isComparison = false;
        }

        // console.log("in redux");
        // console.log(
        // state.temporaryWorkspaces,
        // state.temporaryVersionIndex,
        // state.temporaryWorkspacesList,
        // );
        state.isInProgress = !state.isInProgress;
      }

      state.isTemp = true;
    },
    toggleTemp: (state, action) => {
      state.isTemp = action.payload;
    },
    toggleFetchDefaultWs: (state, action) => {
      state.fetchDefaultWs = action.payload;
    },
    toggleComparison: (state, action) => {
      state.isComparison = action.payload;
    },
  },
});

export const {
  addTempWorkspace,
  permanentToggleIsInProgress,
  viewSelectRefreshToggle,
  deleteTempWorkspace,
  toggleIsInProgress,
  setError,
  temporaryUpdate,
  toggleTemp,
  setJobId,
  setParams,
  setRedirectUrl,
  setIsTemporary,
  setIsConsolidated,
  toggleFetchDefaultWs,
  toggleComparison,
} = temporaryWorkspace.actions;

export const temporaryWorkspaceReducer = temporaryWorkspace.reducer;
